import { render, staticRenderFns } from "./EZUIKitJs.vue?vue&type=template&id=4c106339&scoped=true&"
import script from "./EZUIKitJs.vue?vue&type=script&lang=js&"
export * from "./EZUIKitJs.vue?vue&type=script&lang=js&"
import style0 from "./EZUIKitJs.vue?vue&type=style&index=0&id=4c106339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c106339",
  null
  
)

export default component.exports